// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"783":"600d0b51aaff2bbf","6481":"b8a4b5621a72b1db","6499":"24ba8e1452a96f3f","6578":"b4d036d21c90d96f"}[chunkId] + ".css";
};